(function () {
  'use strict';
  var root = document.getElementById('PNWelcomePopup');
  if (!root) return;
  var KEY = 'pnWelcomePopup.v2', DAY = 86400000, now = Date.now();
  var delay = parseInt(root.dataset.delay, 10) || 5000;
  var scrollPct = parseInt(root.dataset.scroll, 10) || 30;
  var snoozeDays = parseInt(root.dataset.snooze, 10) || 14;
  var dialog = root.querySelector('.pnw__dialog');
  var lastFocus = null, opened = false;

  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
  function write(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function track(name, data) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {} }

  var state = read();
  if (state.until && now < state.until) return;
  if (/[?&]pnw=off\b/.test(location.search)) return;

  function focusables() { return dialog.querySelectorAll('a[href], button:not([disabled])'); }

  function open(trigger) {
    if (opened) return; opened = true;
    cleanup();
    lastFocus = document.activeElement;
    root.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); }); });
    var img = root.querySelector('.pnw__media img'); if (img) img.loading = 'eager';
    setTimeout(function () { var cta = root.querySelector('.pnw__cta'); (cta || dialog).focus({ preventScroll: true }); }, 320);
    document.addEventListener('keydown', onKey);
    write({ until: now + snoozeDays * DAY, seen: now });
    track('pn_popup_viewed', { trigger: trigger });
  }

  function close(reason) {
    root.classList.remove('is-open');
    document.removeEventListener('keydown', onKey);
    setTimeout(function () { root.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    if (reason) track('pn_popup_dismissed', { via: reason });
  }

  function onKey(e) {
    if (e.key === 'Escape') { close('escape'); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(); if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  root.querySelectorAll('[data-pnw-dismiss]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      close(el.classList.contains('pnw__skip') ? 'no_thanks' : el.classList.contains('pnw__close') ? 'close_button' : 'backdrop');
    });
  });
  root.querySelectorAll('[data-pnw-cta]').forEach(function (el) {
    el.addEventListener('click', function () {
      write({ until: now + 365 * DAY, converted: Date.now() });
      track('pn_popup_cta', { action: el.getAttribute('data-pnw-cta') });
    });
  });

  // Open after a short delay, after scrolling part-way, or (desktop) when the mouse heads for the tab bar.
  var timer = setTimeout(function () { open('delay'); }, delay);
  function onScroll() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h > 0 && (window.scrollY / h) * 100 >= scrollPct) open('scroll');
  }
  function onLeave(e) { if (e.clientY <= 0 && !e.relatedTarget) open('exit_intent'); }
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('mouseout', onLeave);
  function cleanup() { clearTimeout(timer); window.removeEventListener('scroll', onScroll); document.removeEventListener('mouseout', onLeave); }
})();